const processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./_custom/_back_to_top'));
    processInclude(require('./_custom/_breadcrumb'));
    processInclude(require('./_custom/_sp_suggestions'));
    processInclude(require('./_custom/_product_list'));
    processInclude(require('./_custom/_agree_check'));
    processInclude(require('./_custom/_qa_accordion'));
    processInclude(require('./_custom/_top_carousel'));
});
